"use client";

import React from "react";
import { Heading, Text, Price } from "@pamperedchef/design-system";
import * as styles from "./AddToCartSliderContent.module.scss";

export interface AddedProductSnapshot {
	sku: string;
	quantity: number;
	name: string;
	imageUrl: string;
	listPrice: number;
	salePrice: number;
}

export interface AddToCartSliderContentProps {
	addedProduct: AddedProductSnapshot;
}

export function AddToCartSliderContent({
	addedProduct
}: AddToCartSliderContentProps): JSX.Element {
	const { sku, quantity, name, imageUrl, listPrice, salePrice } =
		addedProduct;
	const isSale = salePrice < listPrice;
	const subtotal = salePrice * quantity;

	return (
		<div
			className={styles.container}
			data-component="AddToCartSliderContent"
		>
			{/* Product Card Section */}
			<div className={styles.productSection}>
				<div className={styles.card}>
					<div className={styles.imageWrap}>
						{imageUrl ? (
							// eslint-disable-next-line @next/next/no-img-element
							<img
								src={imageUrl}
								alt={name}
								className={styles.image}
							/>
						) : (
							<div className={styles.imagePlaceholder}>
								No Image
							</div>
						)}
					</div>
					<div className={styles.details}>
						<Text tag="p" styledAs="smb" className={styles.name}>
							{name}
						</Text>
						<Text tag="p" styledAs="xsr" className={styles.sku}>
							SKU: {sku}
						</Text>
						<Text tag="p" styledAs="smr" className={styles.qty}>
							Qty: {quantity}
						</Text>
						<div className={styles.pricing}>
							<Price
								display={salePrice}
								strikeThrough={isSale ? listPrice : undefined}
								locale="en-US"
								currency="USD"
								size="small"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
